import { Component } from '@angular/core';
import { NotificationServiceHM, NotificationToastMessage } from './notification-item.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'notificationComponentHM',
  standalone: true,
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.css'],
  imports: [CommonModule]
})
export class NotificationItemComponent {

  message: string = '';
  show: boolean = false;
  subscription: Subscription;
  toasterBackgroundColor: string = '';
  toasterIconBackgroundColor: string = '';
  icon: string = '';
  actionLabel = '';
  private actionCallback: (() => void) | null = null;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private notificationServiceHM: NotificationServiceHM) { }

  ngOnInit(): void {
    this.subscription = this.notificationServiceHM.getToastObservable()
      .subscribe((message: NotificationToastMessage) => {
        this.message = message.text;
        this.actionLabel = message.action?.label ?? '';
        this.actionCallback = message.action?.callback ?? null;

        switch (message.type) {
          case 'success':
            this.toasterBackgroundColor = 'var(--background-success)';
            this.toasterIconBackgroundColor = 'var(--color-success)';
            this.icon = 'po-icon po-icon-ok';
            break;
          
          case 'warning':
            this.toasterBackgroundColor = 'var(--background-warning)';
            this.toasterIconBackgroundColor = 'var(--color-warning)';
            this.icon = 'po-icon po-icon-warning';
            break;
    
          case 'error':
            this.toasterBackgroundColor = 'var(--background-error)';
            this.toasterIconBackgroundColor = 'var(--color-error)';
            this.icon = 'po-icon po-icon-exclamation';
            break;
        }

        this.show = true;
        this.restartAutoHide(message.durationMs ?? 5000);
    });
  }

  defineType(_type: string){
    return;
  }
  closeToaster(){
    this.clearAutoHide();
    this.actionLabel = '';
    this.actionCallback = null;
    this.show = false;
  }

  onActionClick(): void {
    if (!this.actionCallback) { return; }
    const callback = this.actionCallback;
    this.closeToaster();
    callback();
  }

  private restartAutoHide(durationMs: number): void {
    this.clearAutoHide();
    this.hideTimer = setTimeout(() => {
      this.show = false;
      this.actionLabel = '';
      this.actionCallback = null;
      this.hideTimer = null;
    }, durationMs);
  }

  private clearAutoHide(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearAutoHide();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
